import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { ComplianceDetailView } from '../features/compliance/components/ComplianceDetailView';
import { setLastComplianceRoute } from '../features/compliance/lib/navigation';

export const ComplianceDetailPage = () => {
  const { documentId } = useParams<{ documentId: string }>();
  const location = useLocation();

  useEffect(() => {
    setLastComplianceRoute(location.pathname);
  }, [location.pathname]);

  if (!documentId) {
    return <Navigate to="/compliance" replace />;
  }

  return <ComplianceDetailView documentId={documentId} />;
};

ComplianceDetailPage.displayName = 'ComplianceDetailPage';
